import { Link, Outlet, useLocation } from "react-router-dom";

const ResultadosLayout = () => {
  const path = useLocation().pathname;

  return (
    <>
    {/*
      <section className="container reflexNavigation no-bottom">
        <div className="filter-tabs no-bottom">
          <Link
            to="mes-atual"
            className={`tab ${path.includes("/mes-atual") ? "active" : ""}`}
          >
            Mês Atual
          </Link>

          <Link
            to="trimestre-atual"
            className={`tab ${path.includes("/trimestre-atual") ? "active" : ""}`}
          >
            Trimestre Atual
          </Link>
        </div>
      </section>
      */}

      <div className="tab-content">
        <Outlet />
      </div>
    </>
  );
};

export default ResultadosLayout;
